import React,{useState} from "react";
import { Link , useHistory } from "react-router-dom";
import { image_url , connection_string } from "../Util/connection_strings";
import Button from "../Components/Button";
import axios from "axios";

export default function OrderCard({ order ,Setsuccess }) {
  console.log("order======>", order);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const { pathname } = history?.location

  const [refundData, setRefundData] = useState({
    order_id: order?._id,
    product_id: order?.product?.product_id?._id,
    reason: "",
    refundimage: "",
  })

  const RefundOrder = async () => {
    setLoading(true)
    setIsPasswordModalOpen(false)
    const formData = new FormData();
    formData.append("order_id", order?._id);
    formData.append("product_id", order?.product?.product_id?._id);
    formData.append("vendorid",  order?.vendor  );
    formData.append("reason", refundData.reason);
    formData.append("customerName", order?.name);
    formData.append("price", order?.price_info?.total);

    if(refundData.refundimage){
      formData.append("refundimage", refundData.refundimage);
    }

    try {
      const Token = localStorage.getItem("TokenUser");
      const response = await axios.post(connection_string+'/order/refund', formData, {
          headers: {
              Authorization: `Bearer ${Token}`, // Attach token to headers
              "Content-Type": "multipart/form-data",
          },
      });
      setLoading(false)
      if(response.data.message){
        setRefundData({});
        Setsuccess(true)
        window.location.reload();

      }
      console.log("Refund response:", response.data);
      
     
  } catch (error) {
      console.error("Refund failed:", error);
  }
    

  }


  return (
    <>
      <tr>
        <td colSpan={6}>
          <h3 className="ff-thunder fc-purple mb-0" />
        </td>
        <td colSpan={6} />
      </tr>
      <tr className="bb-double">
        <td>
          <img
            src={`${image_url}${order?.product?.product_id?.images[0]}`}
            className="img-fluid"
          />
        </td>
        <td>{order?.product?.product_id?.name}</td>
        <td align="center">
          <div className="quantity buttons_added">
            {/* <input
              type="number"
              disabled
              name="quantity"
              title="Qty"
              className="input-text qty text"
              value={order?.product?.quantity}
              readOnly
            /> */}
            {order?.product?.quantity}
          </div>
        </td>
        <td align="center">${order?.product?.product_id?.price}</td>
        <td align="center">${order?.price_info?.tax}</td>
        <td align="center">${order?.price_info?.shipping_cost}</td>
        {/* <td>{order?.product?.model}</td>
        <td>{order?.product?.avatar_type}</td> */}

        <td align="center">${order?.price_info?.total}</td>
        <td align="center">{order?.order_status}</td>
        <td align="right">
          <Link to={`/order/${order?._id}`}>View Order</Link>
        </td>
        {
          order && order?.order_status === "Delivered" && pathname === `/order/${order?._id}` && (
            <td align="right">
              <button onClick={() => setIsPasswordModalOpen(true)}>
                
                {loading && order ? <i className="fas fa-spinner fa-spin"></i> : "Refund"}
                </button>
            </td>
          )
        }
        
      </tr>


        {isPasswordModalOpen && (
              <div className="modal fade login-modal show" style={{ display: "block" }}>
                <div className="modal-dialog modal-dialog-centered" role="document">
                  <div className="modal-content modal-cstm">
                    <div className="modal-header modal-headerClose">
                      <button type="button" className="close" onClick={() => setIsPasswordModalOpen(false)}>
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div className="modal-body p-20-40">
                      <div className="text-center mt-20">
                        <h3 className="ff-thunder fc-purple">Refund Order</h3>
                      </div>
                      <div className="text-left">
                      <div className="row">
                          <div className="col mt-30">
                            <label>Order Id*</label>
                            <input 
                              type="text" 
                              className="form-control input-cstm" 
                              placeholder="Current Password" 
                               value={order?._id} 
                               disabled
                              //  onChange={(e) => setCurrent(e.target.value)} /
                              />
                          </div>
                        </div>
                        <div className="row">
                        <label>Product*</label>
                            {/* Left Side - Image */}
                            <div className="col-md-4 text-center">
                              <img
                                src={`${image_url}${order?.product?.product_id?.images[0]}`}
                                className="img-fluid"
                                alt="Product"
                                style={{ maxWidth: "100px", height: "auto" }} // Adjust size as needed
                              />
                            </div>

                            {/* Right Side - Input */}
                            <div className="col-md-8">
                              <label>{order?.product?.product_id?.name}</label>
                             
                            </div>
                          </div>
                        <div className="row">
                          <div className="col mt-30">
                            <label>Reason for Refund*</label>
                            <input 
                              type="file" 
                              className="form-control input-cstm" 
                              placeholder="New Password" 
                              onChange={(e) => setRefundData({...refundData , refundimage : e.target.files[0]})} 
                              />
                              {" "}
                              <input 
                              type="text" 
                              className="form-control input-cstm" 
                              placeholder="Reason for Refund" 
                              // value={password} 
                              onChange={(e) => setRefundData({...refundData , reason : e.target.value})} 
                              />
                          </div>
                        </div>
                       
                      </div>
                      <div className="text-center">
                        <div className="row">
                          <div className="col mt-40 text-center mb-20">
                            <Button className="btn-orange" onClick={RefundOrder} >
                              UPDATE
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
    </>
  );
}
